"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridCheckboxLabelId = exports.gridCheckboxInputId = exports.gridCheckboxId = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const controls_1 = require("../../controls");
const GridCheckboxWrapper = styled_components_1.default.div `
    width: 100%;

    input {
        display: none;
    }

    label {
        display: flex;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
    }
`;
exports.gridCheckboxId = 'grid-checkbox-wrapper';
exports.gridCheckboxInputId = 'grid-checkbox-input';
exports.gridCheckboxLabelId = 'grid-checkbox-label';
class GridCheckbox extends react_1.Component {
    constructor(props) {
        super(props);
        this.input = react_1.default.createRef();
        this.inputId = Math.random().toString(16);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(e) {
        const { onClick, disabled } = this.props;
        e.stopPropagation();
        e.preventDefault();
        if (this.input.current && !disabled) {
            onClick(!this.input.current.checked, e);
        }
    }
    render() {
        const { checked, indeterminate, disabled } = this.props;
        return (react_1.default.createElement(GridCheckboxWrapper, { "data-selector-id": exports.gridCheckboxId, onClick: this.handleClick },
            react_1.default.createElement("input", { "data-selector-id": exports.gridCheckboxInputId, type: "checkbox", id: this.inputId, ref: this.input, checked: checked, disabled: disabled, readOnly: true }),
            react_1.default.createElement("label", { htmlFor: this.inputId, "data-selector-id": exports.gridCheckboxLabelId },
                react_1.default.createElement(controls_1.Checkbox, { buildIn: true, checked: checked, disabled: disabled, indeterminate: indeterminate }))));
    }
}
exports.default = GridCheckbox;
//# sourceMappingURL=GridCheckbox.js.map